<template>
    <div
        class="loading-preview preview-button"
        v-if="requestCreating"
    >
        <div class="generation-spinner">
            <span
                v-loading="true"
                class="preview-spinner"
            >
            </span>
        </div>
        <p
            class="loading-title"
            :style="{'font-size': fontSize, 'margin': margin}"
        >Preview will start soon</p>
    </div>
    <div
        class="preview-button"
        v-else
    >
        <button
            class="button"
            :style="{'background-color': stepData.iconColor, 'margin-bottom': margin}"
            @click="createNewPreview()"
        >
            <img
                class="step-icon"
                :src="`/static/icon/${stepData.iconUrl}`"
                :style="{'margin-left': '3px'}"
            >
        </button>
        <p
            v-if="stepData.linkText"
            class="preview-indice"
            :style="{'font-size': fontSize, 'margin': margin}"
            @click="createNewPreview()"
        >
            {{stepData.linkText}}
        </p>
    </div>
</template>

<script>
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    export default {

        name: 'Start',
        mixins: [PreviewStepMixin],
        props: {
            requestCreating: {
                type: Boolean,
                default: false,
            }
        },

        data () {
            return {

            };
        },
        methods: {

        }
    };
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Start/index.vue